import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { getItemWebStorage } from "../../../features/webStorageSaver";
import { logout } from "../../../features/auth";
import type { IRoadAccidentSegments } from "../../../models/storeModels/IRoadAccidentSegments";

function getInitialState(){
    const initialState: IRoadAccidentSegments = {
        roadAccidentSegmentsMapYearFilter: getItemWebStorage('diagnosticsYearFilters')?.roadAccidentSegmentsMap ?? `${new Date().getFullYear()}`,
    }
    return initialState
}

export const roadAccidentSegmentsSlice = createSlice({
    name: 'roadAccidentSegments',
    initialState: getInitialState(),
    reducers: {
        setRoadAccidentSegmentsMapYearFilter(state, action: PayloadAction<any>) {
            state.roadAccidentSegmentsMapYearFilter = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return getInitialState()
        })
    },
})

export const { setRoadAccidentSegmentsMapYearFilter } = roadAccidentSegmentsSlice.actions
export const roadAccidentSegmentsReducer = roadAccidentSegmentsSlice.reducer;
